import { BaseError } from './base.js';
export class ValidationError extends BaseError {
    httpStatus = 400;
}
